<template>
  <div class="content">
    <system :leftList="leftList"></system>
    <div class="pageBox">
      <div class="breadcrumb">
        <el-breadcrumb separator="/">
          <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
          <el-breadcrumb-item>平台投诉/建议</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
      <div class="pageSerch">
        <el-card class="box-card" shadow="never">
          <div slot="header" class="clearfix">
            <span class="cardTitle">投诉/建议列表</span>
          </div>
          <el-form ref="ruleForm" :model="ruleForm">
            <el-row :gutter="20">
              <el-col :span="6">
                <el-form-item label="联系方式">
                  <el-input
                    maxlength="50"
                    clearable
                    v-model="ruleForm.name"
                    placeholder="请输入联系方式"
                  ></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item>
                  <el-button type="primary" @click="getList()" class="btn"
                    >查询</el-button
                  >
                  <el-button @click="resetForm()">重置</el-button>
                </el-form-item>
              </el-col>
            </el-row>
          </el-form>
        </el-card>
      </div>
      <div class="pageTab">
        <el-table ref="scrollTable" :data="tableData" style="width: 100%">
          <el-table-column label="账号类型" align="center">
            <template slot-scope="scope">
              {{ scope.row.type == 1 ? "用户" : "保安" }}
            </template>
          </el-table-column>
          <el-table-column prop="accountPhone" label="联系方式" align="center">
          </el-table-column>
          <el-table-column prop="content" label="投诉与建议" align="center">
          </el-table-column>
          <el-table-column label="图片" align="center" width="300">
            <template slot-scope="scope">
              <div
                style="display: flex; flex-wrap: wrap; justify-content: center"
              >
                <el-image
                  v-if="item"
                  :src="item"
                  alt=""
                  v-for="(item, index) in scope.row.img"
                  :key="index"
                  style="width: 50px; height: 50px; margin-left: 10px"
                  :preview-src-list="scope.row.img"
                >
                </el-image>
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="gmtCreate" label="创建时间" align="center">
          </el-table-column>
        </el-table>
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :page-sizes="[10, 20, 30, 50]"
          :page-size="pageSize"
          layout="total, prev, pager, next,sizes"
          :total="total"
        >
        </el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import system from "../../components/system_left.vue";
export default {
  components: {
    system,
  },
  data() {
    return {
      leftList: this.Plugins.customerData(),
      ruleForm: {
        name: "",
      },
      tableData: [],
      page: 1,
      pageSize: 10,
      total: 0,
    };
  },
  mounted() {
    this.getList();
  },
  methods: {
    resetForm() {
      this.ruleForm.name = "";
      this.getList();
    },
    handleSizeChange(val) {
      this.pageSize = val;
      this.getList();
    },
    handleCurrentChange(val) {
      this.page = val;
      this.getList();
    },
    getList() {
      let param = {
        page: this.page,
        pageSize: this.pageSize,
        queryParams: [],
      };
      if (this.ruleForm.name != "") {
        param.queryParams.push({
          name: "account_phone",
          type: "select",
          values: [{ itemKey: this.ruleForm.name }],
        });
      }
      this.$axios
        .post(`/admapi/workbenches/opinions`, param)
        .then(({ data }) => {
          let arr = data.items || [];
          for (var i = 0; i < arr.length; i++) {
            arr[i].img = arr[i].img
              .substring(1, arr[i].img.length - 1) // 去掉 `"[` 和 `]"`
              .split(", ") // 按逗号+空格分割
              .map((url) => url.trim()); // 去除可能的空格;
          }
          this.tableData = arr;
          this.total = data.page.totalRows;
        })
        .catch()
        .finally();
    },
  },
};
</script>
<style scoped></style>
